import React from 'react';
import { connect } from 'react-redux';
import { Alert, Row } from 'react-bootstrap';
import RequestTypeBlock from 'containers/request/RequestTypeBlock';
import AgreementPreview from 'containers/request/AgreementPreview';
import SignVendorAgreement from 'containers/request/SignVendorAgreement';
import { submissionTypes } from 'helpers/RequestHelper';

const RequestNew = ({ user }) => {
  if (!user.cbrsvendoragreementflag) return <SignVendorAgreement />;
  return (
    <div>
      <h1>Submit New Request</h1>
      <Alert bsStyle="info">Please choose the request type.</Alert>
      <Row>
        {submissionTypes.map((reqItem, i) => {
          return <RequestTypeBlock request={reqItem} key={i} />;
        })}
      </Row>
      <AgreementPreview />
    </div>
  );
};

function mapStateToProps({ user }) {
  return { user };
}

export default connect(mapStateToProps)(RequestNew);



// WEBPACK FOOTER //
// ./src/containers/request/RequestNew.js